import { gql } from '@apollo/client';

// eslint-disable-next-line import/prefer-default-export
export const GET_USERS = gql`
  query userList($filter: UsersListFilter!) {
    userList(filter: $filter) {
      total
      complimentaryUserCount
      licensedUserCount
      purchasedUserLimit
      data {
        id
        name
        email
        isDisabled
        isActive
        roles
        phoneNo
        countryCode
        assignedAsApprover
        lastUpdated
        inspectionCount
        instructionCount
        approvalGivenCount
        agencies {
          id
          name
        }
        projectUsers {
          roles
          project {
            name
            isActive
          }
        }
      }
    }
  }
`;

export const USER_ONBOARD_DROPDOWN_LIST = gql`
  query userOnboardDropdownList($filter: UsersListFilter!) {
    userOnboardDropdownList(filter: $filter) {
      total
      activeUserCount
      totalUserCount
      data {
        id
        name
        email
        isDisabled
        isActive
        roles
        phoneNo
        countryCode
        assignedAsApprover
        lastUpdated
        inspectionCount
        instructionCount
        approvalGivenCount
        projectUsers {
          project {
            name
          }
        }
      }
    }
  }
`;

export const USER_AGENCY_DROPDOWN_LIST = gql`
  query UserAgencyDropdownList($filter: CommonFilter!) {
    userAgencyDropdownList(filter: $filter) {
      total
      data {
        id
        user {
          name
          email
        }
        agency {
          name
        }
      }
    }
  }
`;

export const USER_EQC_TYPE_STAGE_APPROVAL_LIST = gql`
  query userEqcTypeStageApprovalList(
    $filter: ProjectEqcTypeStageApprovalFilter!
  ) {
    userEqcTypeStageApprovalList(filter: $filter) {
      total
      requiredProjectEqcTypeStageLevel {
        projectEqcTypeStageId
        levelNumber
      }
      userAgencyIds
      data {
        id
        stageId
        name
        projectName
        projectEqcTypeName
        levelNumber
        levelName
        projectId
        projectUserId
        projectEqcTypeStageApprovals {
          id
          internalApproverId
          userAgencyId
          externalUserApproverId
          levelNumber
          levelName
          internalApproverName
          externalUserApproverName
        }
      }
    }
  }
`;
export const USER_PROJECT_LIST = gql`
  query userProjectList($filter: UserProjectFilter!) {
    userProjectList(filter: $filter) {
      total
      requiredProjectIds
      data {
        id
        projectId
        roles
        project {
          name
        }
        assignedChecklistCount
        assignedRfiCount
        approvalPendingStageCount
      }
    }
  }
`;

export const GET_USERS_DROPDOWN_LIST = gql`
  query userDropdownList($filter: UsersListFilter!) {
    userDropdownList(filter: $filter) {
      total
      data {
        id
        name
      }
    }
  }
`;

export const REPLICATE_USER_DROPDOWN_LIST = gql`
  query ReplicateUserDropdownList($filter: ReplicateUsersListFilter!) {
    replicateUserDropdownList(filter: $filter) {
      total
      data {
        id
        agency {
          name
        }
        user {
          name
        }
      }
    }
  }
`;

export const GLOBAL_AGENCY_DROPDOWN_LIST = gql`
  query GlobalAgencyDropdownList($filter: AgencyFilter) {
    globalAgencyDropdownList(filter: $filter) {
      total
      data {
        id
        name
        type
        tenantId
        contacts {
          id
          name
          phoneNo
          email
          designation
          agencyId
          createdBy
          tenantId
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
    }
  }
`;

export const GET_PROFILE = gql`
  query getLoggedInUser {
    getLoggedInUser {
      id
      name
      email
      password
      roles
      profileImage
      phoneNo
      createdBy
      profileImage
      isDisabled
      isActive
      countryCode
      emailVerified
      numberVerified
      forcePasswordReset
      isLocal
      tenants {
        id
        tenant {
          id
          organizationName
        }
      }
      projectUsers {
        id
        roles
        access
      }
      tenantUser {
        id
        tenant {
          id
          organizationName
          adminEmail
          ownerName
          phoneNumber
          logo
          userLimit
          inspectionAssetLimit
          instructionAssetLimit
          registerAssetLimit
          access
          timeZone
          addOn
          maxApprovalLevel
          registerMaxApprovalLevel
          featureApprovalRequestConfig {
            stageApprovalRequestSent
            stageApprovalMaxLevelRequestSent
            stageMaxLimitRequestSent
            issueTagRequestSent
            issueRecommendationRequestSent
            inspectionAssetLimitRequestSent
          }
          featureConfig {
            stageMaxLimit
            issueTag
            issueRecommendation
          }
          subscription {
            id
            validTill
            status
            planObj {
              id
              name
            }
          }
        }
      }
    }
  }
`;
